import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Box,
  Collapse,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { Icon } from 'components/Icon';
import { DeleteModalButton } from 'components/Modal/DeleteModalButton';
import { MaxItems } from 'components/PanelBox/MaxItems';
import { TreeConectors } from 'components/TreeConectors';
import { AppListSummary } from 'pages/SetupAppHome/AppListSummary';
import { useState } from 'react';
import { useAppHomeStore } from 'store/appHomeStore';

const iconButtonSize = {
  width: '40px',
  height: '40px',
};

export const CollapseRow = ({
  children,
  listId,
  edit,
  count,
  list,
  disabled = false,
}) => {
  const [open, setOpen] = useState();
  const [editMode, setEditMode] = useState(edit ?? true);
  const toggleEdit = () => setEditMode(v => !v);
  const { getTitleById, setTitleById, removeAppListItem } = useAppHomeStore();

  return (
    <Box data-no-dnd={disabled ? 'true' : 'false'}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'min-content auto auto',
          padding: '0 19px',
          minHeight: '40px',
          alignItems: 'center',
          '& p': {
            paddingLeft: '11px',
          },
        }}>
        <IconButton
          sx={{
            border: 'solid 1px #6F6B7D',
            color: '#6F6B7D',
            width: 26.3,
            height: 26.3,
          }}
          aria-label="expandir linha"
          size="small"
          data-no-dnd="true"
          onClick={() => setOpen(!open)}>
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>

        {editMode ? (
          <TextField
            value={getTitleById(listId)}
            size="small"
            placeholder="Insira o título"
            sx={{
              marginLeft: '11px',

              '& label.Mui-focused': {
                color: '#A0AAB4',
              },
              '& .MuiInput-underline:after': {
                borderBottomColor: '#B2BAC2',
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#E0E3E7',
                  borderRadius: 0,
                },
                '&:hover fieldset': {
                  borderColor: '#B2BAC2',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#6F7E8C',
                },
              },
            }}
            onChange={({ target }) => setTitleById(listId, target.value)}
          />
        ) : (
          <Typography
            variant="body2"
            sx={{ fontWeight: 'bold', fontSize: '14px', color: '#6F6B7D' }}>
            {getTitleById(listId)}
          </Typography>
        )}

        <Box display="flex" justifyContent="flex-end">
          {!editMode && (
            <IconButton
              sx={iconButtonSize}
              disabled={disabled}
              data-no-dnd="true"
              size="small"
              onClick={toggleEdit}>
              <Icon name="edit" />
            </IconButton>
          )}
          {editMode && (
            <IconButton
              sx={iconButtonSize}
              data-no-dnd="true"
              size="small"
              onClick={toggleEdit}
              disabled={disabled}>
              <Icon name="save" />
            </IconButton>
          )}
          <DeleteModalButton
            disabled={disabled}
            itemName={getTitleById(listId)}
            itemSubject="Home list"
            onDelete={() => removeAppListItem(listId)}
          />
          <IconButton sx={iconButtonSize} size="small">
            <Icon name="move" />
          </IconButton>
        </Box>
      </Box>

      <Collapse in={open} data-no-dnd="true">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '52px auto',
            paddingLeft: '6px',
            position: 'relative',
          }}>
          <div>
            <TreeConectors.Line
              sx={{
                position: 'absolute',
                height: '180px',
                top: '-6.6px',
              }}
            />
          </div>
          <Box
            sx={{
              display: 'grid',
              alignItems: 'center',
              borderRightWidth: 0,
              borderLeftWidth: 0,
            }}>
            <AppListSummary list={list} padding="10px 10px" />
            <Box
              sx={{
                backgroundColor: '#F9FAFB',
                color: '#475467',
                display: 'grid',
                gridTemplateColumns: '209px auto auto',
                alignItems: 'center',
                padding: '12px 18px',
                border: 'solid 1px #EAECF0',
                borderBottom: 'solid 1px #EAECF0',
                borderRightWidth: 0,
                borderLeftWidth: 0,
              }}>
              <Typography variant="body2" fontWeight={500}>
                Thumbnail
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                Título
              </Typography>
              <MaxItems count={count} />
            </Box>
          </Box>
        </Box>
        {children}
      </Collapse>
    </Box>
  );
};
